import React from "react";
import Sections from "./Sections";

function Main({ videoID, playerPlay, mediaSize, mediaType }) {
  /** img src extension added in picture element in order to use webp */
  let imgMedia_2 = "";
  if (mediaSize === "sm") {
    imgMedia_2 = "/img/mc-uni-sxn-04-sm";
  } else {
    imgMedia_2 = "/img/mc-uni-sxn-04";
  }

  const sectionAttrs = [
    {
      className: "cta-2",
      id: "cta-2",
      title: ["Purchase the ", <b key="bold1">Future</b>, " - Today!"],
      tagline: ["Enter Your Space - Find Your Deal"],
      content: 1050,
      img: "",
      imported: "",
    },
    {
      className: "cta-1",
      id: "cta-5",
      title: "Advanced DC Inverter Technology",
      tagline: "NOT Your Ordinary Heat Pump",
      content: false,
      img: {
        className: "sxn-img",
        id: "cta-5-img",
        src: "/img/uni-c-reveal-02.png",
        alt: "MRCOOL Universal Condenser sliding reveal of inside",
        title: "MRCOOL Universal Condenser sliding reveal of inside",
      },
      imported: "",
    },
    {
      className: "cta-2",
      id: "eco-rebates-bar",
      title: false,
      tagline: false,
      content: false,
      img: false,
      imported: false,
    },
    {
      className: "cta-2",
      id: "cta-6",
      title: ["Purchase the ", <b key="bold1">Future</b>, " - Today!"],
      tagline: ["Enter Your Space - Find Your Deal"],
      content: 1450,
      img: "",
      imported: "",
    },
    {
      className: "cta-1",
      id: "cta-1",
      title: "The Future is Cool",
      tagline: [
        "Give the MRCOOL",
        <span key="reg1" className="reg-mark">
          ®
        </span>,
        " Universal",
        <span key="reg2" className="reg-mark">
          ®
        </span>,
        "A Spin",
      ],
      content: "",
      img: "",
      imported: "",
    },
    {
      className: "cta-2",
      id: "cta-4",
      title: false,
      tagline: false,
      content: false,
      img: {
        className: "sxn-img",
        id: "cta-4-img",
        src: imgMedia_2,
        alt: "MRCOOL Universal DC Inverter Reliability backed by warranty",
        title: "MRCOOL Universal DC Inverter Reliability backed by warranty",
      },
      imported: "",
    },
    {
      className: "cta-2",
      id: "cta-10",
      title: ["Purchase the ", <b key="bold1">Future</b>, " - Today!"],
      tagline: ["Enter Your Space - Find Your Deal"],
      content: 1050,
      img: "",
      imported: "",
    },
    {
      className: "cta-1",
      id: "cta-7",
      title: false,
      tagline: false,
      content: false,
      img: false,
      imported: "",
    },
    {
      className: "cta-1",
      id: "cta-12",
      title: "Advanced DC Inverter Technology",
      tagline: "NOT Your Ordinary Heat Pump",
      content: false,
      img: {
        className: "sxn-img",
        id: "cta-5-img",
        src: "/img/uni-c-reveal-04.png",
        alt: "MRCOOL Universal Condenser sliding reveal of inside",
        title: "MRCOOL Universal Condenser sliding reveal of inside",
      },
      imported: "",
    },
    {
      className: "cta-1",
      id: "cta-9",
      title: "Need More Info?",
      tagline: "Check Out Our Docs",
      content: "Robots Love Docs",
      img: "",
      imported: "",
    },
    {
      className: "cta-2",
      id: "cta-11",
      title: ["Purchase the ", <b key="bold1">Future</b>, " - Today!"],
      tagline: ["Enter Your Space - Find Your Deal"],
      content: 1450,
      img: "",
      imported: "",
    },
  ];

  return (
    <main>
      {sectionAttrs.map((sectionAttr) => (
        <Sections
          key={sectionAttr.id}
          {...sectionAttr}
          videoID={videoID}
          playerPlay={playerPlay}
          mediaSize={mediaSize}
          mediaType={mediaType}
        />
      ))}
    </main>
  );
}

export default Main;
